<template>
  <main class="post text-white">
    <template v-if="post">
      <video
        class="post__video"
        :style="'background-image: url(https://res.cloudinary.com/evanagee/image/upload/c_scale,q_88,w_1500/v1535722159/fanorcan/' + post.poster+');'"/>
      <h3 class="post__title mt-5" v-html="post.title"></h3>
      <div class="post__meta flex justify-between mt-2 mb-5 text-xs text-grey">
        <div v-html="post.artist"></div>
        <div class="text-grey" v-html="post.views + ' Views'"></div>
      </div>

      <fan-can-bar class="fan-can-bar--rounded" :post="post"></fan-can-bar>

      <div class="post__actions flex mt-3">
        <div class="post__actions__percentage justify-center">
          <div class="post__actions__percentageNumber font-light flex justify-center">
            <span v-html="percentage.number"></span>
            <span class="text-2xl">%</span>
          </div>
          <div class="post__actions__percentageLabel font-extrabold text-xl flex justify-center" v-html="percentage.label"></div>
        </div>

        <div class="post__actions__buttons flex flex-1 justify-end items-center content-center">
          <button
            class="button button--round bg-green"
            :class="voteButtonClass('fan')"
            @click="vote('fans')"
            :disabled="!voteStatus.canVote">
            <i class="fal fa-heart"></i>
          </button>
          <button
            class="button button--round bg-red"
            :class="voteButtonClass('can')"
            @click="vote('cans')"
            :disabled="!voteStatus.canVote">
            <i class="fal fa-trash-alt"></i>
          </button>
        </div>
      </div>

      <artist-chicklet v-if="artist" class="mt-5" :artist="artist" />
    </template>
    <Loader v-else />
  </main>
</template>

<script>
import { db } from '@/main'
import Loader from '@/components/shared/Loader.vue'
import FanCanBar from '@/components/FanCanBar/FanCanBar.vue'
import ArtistChicklet from '@/components/Artist/ArtistChicklet.vue'

export default {
  props: ['user'],
  components: {
    FanCanBar,
    Loader,
    ArtistChicklet
  },

  data () {
    return {
      post: false,
      artist: false,
      voteStatus: {
        canVote: false,
        vote: ''
      },
      unsubscribe: false
    }
  },

  mounted () {
    this.getPost()
  },

  destroyed () {
    this.unsubscribe()
  },

  computed: {
    voteButtonClass () {
      return which => {
        if (this.voteStatus.canVote) {
          return ''
        } else {
          return this.voteStatus.vote === which ? 'button--selected' : 'button--disabled'
        }
      }
    },

    percentage () {
      let percentage = {
        number: 0,
        label: ''
      }
      if (this.post.fans > this.post.cans) {
        percentage.label = 'Fanned'
        percentage.number = Math.round(this.post.fans / (this.post.fans + this.post.cans) * 100)
      } else {
        percentage.label = 'Canned'
        percentage.number = Math.round(this.post.cans / (this.post.fans + this.post.cans) * 100)
      }
      return percentage
    }
  },

  methods: {
    getPost () {
      let self = this
      this.unsubscribe = db.collection('posts')
        .where('slug', '==', this.$route.params.postSlug)
        .onSnapshot(function (querySnapshot) {
          self.post = querySnapshot.docs[0].data()
        }, function (error) {
          console.log(error)
        })
    },

    getArtist (id) {
      db.collection('artists').doc(id).get()
        .then(res => {
          this.artist = res.data()
        })
    },

    vote (val) {
      this.$store.dispatch('post/voteOnPost', {
        vote: val,
        post: this.post
      })
    },

    checkVoteStatus () {
      let fanCanRef = db.collection('fanscans')
      let fanCanSearch = fanCanRef.where('user', '==', this.user.uid).where('post', '==', this.post.id)

      fanCanSearch.get().then(res => {
        this.voteStatus.canVote = res.size < 1
        if (res.size > 0) {
          this.voteStatus.vote = res.docs[0].data().type
        }
      })
    }
  },

  watch: {
    post (val, oldValue) {
      let bgClass = val.fans > val.cans ? 'background--fanned' : 'background--canned'
      this.$store.dispatch('global/updateBackground', bgClass)

      this.checkVoteStatus()

      if (!this.artist) {
        this.getArtist(val.artist)
      }
    }
  }
}
</script>
